export const convertBytesToMb = (bytes: number) => bytes / 1024 / 1024;
